import { categories } from "@/mocks/categories";

const gridImages = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Trendy%20fashion%20sneakers%20on%20minimal%20cream%20surface%20with%20soft%20warm%20coral%20tinted%20backdrop%2C%20clean%20product%20photography%2C%20gentle%20studio%20lighting%2C%20contemporary%20sneaker%20display%2C%20modern%20ecommerce%20aesthetic%2C%20bright%20natural%20look%2C%20simple%20composition&width=600&height=750&seq=grid-shoes-01&orientation=portrait"
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20draped%20on%20minimal%20wooden%20chair%20with%20sage%20green%20tinted%20wall%20background%2C%20soft%20natural%20lighting%2C%20warm%20atmospheric%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20casual%20lifestyle%20vibe&width=600&height=750&seq=grid-hoodies-02&orientation=portrait"
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20beige%20linen%20fabric%2C%20soft%20diffused%20daylight%2C%20minimalist%20product%20photography%2C%20clean%20crisp%20folds%2C%20modern%20apparel%20display%2C%20earthy%20neutral%20tones&width=600&height=750&seq=grid-tshirts-03&orientation=portrait"
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Stylish%20denim%20jacket%20on%20minimal%20hanger%20against%20warm%20coral%20peach%20colored%20wall%2C%20clean%20studio%20lighting%2C%20professional%20fashion%20photography%2C%20modern%20catalog%20style%2C%20simple%20elegant%20composition%2C%20soft%20shadows&width=600&height=750&seq=grid-jackets-04&orientation=portrait"
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Casual%20linen%20pants%20flat%20lay%20on%20cream%20textured%20surface%20with%20warm%20terracotta%20accent%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20summer%20fashion%20vibe&width=600&height=750&seq=grid-pants-05&orientation=portrait"
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20baseball%20cap%20displayed%20on%20minimal%20white%20pedestal%20with%20soft%20sage%20green%20background%20wash%2C%20clean%20product%20photography%2C%20gentle%20studio%20lighting%2C%20modern%20accessory%20display&width=600&height=750&seq=grid-headwear-06&orientation=portrait"
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Matching%20fashion%20set%20of%20hoodie%20and%20joggers%20laid%20out%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20coordinated%20outfit%20display%2C%20modern%20aesthetic&width=600&height=750&seq=grid-sets-07&orientation=portrait"
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20neatly%20folded%20on%20warm%20beige%20linen%2C%20gentle%20diffused%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20simple%20composition%2C%20neutral%20earthy%20tones%2C%20modern%20display&width=600&height=750&seq=grid-underwear-08&orientation=portrait"
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Sports%20jersey%20hanging%20on%20minimal%20wooden%20hanger%20against%20warm%20coral%20tinted%20wall%2C%20clean%20studio%20lighting%2C%20professional%20product%20photography%2C%20modern%20sportswear%20display&width=600&height=750&seq=grid-jersey-09&orientation=portrait"
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20including%20watch%20and%20bracelet%20on%20minimal%20cream%20surface%20with%20sage%20green%20accents%2C%20soft%20natural%20lighting%2C%20clean%20elegant%20product%20photography%2C%20modern%20lifestyle%20display&width=600&height=750&seq=grid-accessories-10&orientation=portrait"
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20leather%20crossbody%20bag%20on%20warm%20beige%20surface%20with%20soft%20terracotta%20background%2C%20gentle%20studio%20lighting%2C%20luxury%20accessory%20photography%2C%20minimalist%20modern%20display%2C%20clean%20composition&width=600&height=750&seq=grid-bags-11&orientation=portrait"
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20coiled%20elegantly%20on%20cream%20surface%20with%20warm%20earthy%20background%2C%20soft%20diffused%20lighting%2C%20minimalist%20product%20photography%2C%20gold%20buckle%20detail%2C%20luxury%20aesthetic&width=600&height=750&seq=grid-belts-12&orientation=portrait"
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20minimal%20cream%20surface%2C%20sage%20green%20foliage%20accent%2C%20soft%20natural%20lighting%2C%20luxury%20fragrance%20display%2C%20modern%20minimalist%20aesthetic&width=600&height=750&seq=grid-perfumes-13&orientation=portrait"
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Miscellaneous%20fashion%20items%20and%20lifestyle%20accessories%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20eclectic%20display&width=600&height=750&seq=grid-other-14&orientation=portrait"
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-xs tracking-widest uppercase text-foreground-400 font-label mb-2">
            Browse Collections
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
            Shop by <span className="italic text-primary-500">Category</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {gridImages.map((item) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-lg overflow-hidden bg-background-50 hover:ring-2 hover:ring-primary-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[4/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="px-4 py-3">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap truncate">
                  {item.name}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}